// src/hooks/useFeature.js

import { useSelector } from "react-redux";

export default function useFeature() {
  const { accessFeatures } = useSelector((state) => state.clientFunction?.companiesDB || {});
  const clientfeatures = Array.isArray(accessFeatures?.capabilities) ? accessFeatures.capabilities : [];
  const modules = Array.isArray(accessFeatures?.modules) ? accessFeatures.modules : [];
  const unavailable = Array.isArray(accessFeatures?.unavailableModules) ? accessFeatures.unavailableModules : [];

  const hasModule = (module) => modules.includes(module) && !unavailable.includes(module);
  const hasCapability = (capability) => clientfeatures.includes(capability);
  // Existing callers can use hasFeature for both module IDs and capabilities.
  const hasFeature = (value) => value?.includes(".") ? hasCapability(value) : hasModule(value);
  const hasAllFeatures = (features = []) => Array.isArray(features) && features.every(hasFeature);
  const hasAnyFeature = (features = []) => Array.isArray(features) && features.some(hasFeature);
  const getFeatures = () => clientfeatures;

  return {
    accessFeatures,
    clientfeatures,
    modules,
    hasModule,
    hasCapability,

    hasFeature,

    hasAllFeatures,

    hasAnyFeature,

    getFeatures,
  };
}

// // src/hooks/useFeature.js

// import { useSelector } from "react-redux";

// export default function useFeature() {
//   // Logged-in company information
//   const { clientData, companyFeatures } = useSelector(
//     (state) => state.clientFunction?.companiesDB,
//   );

//   // Features enabled by subscription plan
//   const features = companyFeatures || {};

//   /**
//    * Check one feature
//    *
//    * Example:
//    * hasFeature("finance")
//    */
//   const hasFeature = (feature) => {
//     if (clientData?.founderAccount) {
//       return true;
//     }
//     return features[feature] === true;
//   };

//   /**
//    * Check multiple features.
//    * User/company must have ALL features.
//    *
//    * Example:
//    *
//    * hasAllFeatures([
//    *    "inventory",
//    *    "warehouse"
//    * ])
//    */
//   const hasAllFeatures = (featureList = []) => {
//     if (!Array.isArray(featureList)) {
//       return false;
//     }

//     return featureList.every((feature) => features[feature] === true);
//   };

//   /**
//    * Check multiple features.
//    * Company needs ANY one feature.
//    *
//    * Example:
//    *
//    * hasAnyFeature([
//    *    "finance",
//    *    "accounting"
//    * ])
//    */
//   const hasAnyFeature = (featureList = []) => {
//     if (!Array.isArray(featureList)) {
//       return false;
//     }

//     return featureList.some((feature) => features[feature] === true);
//   };

//   /**
//    * Return all enabled features
//    */
//   const getFeatures = () => features;

//   return {
//     features,

//     hasFeature,

//     hasAllFeatures,

//     hasAnyFeature,

//     getFeatures,
//   };
// }

// // 9(((((((((((((((((((())))))))))))))))))))
// // Expected Redux Data

// // This expects your clientData to contain:

// // clientData: {

// //     companyId: "company001",

// //     subscription: {

// //         planId: "premium"

// //     },

// //     features: {

// //         inventory: true,

// //         sales: true,

// //         purchase: true,

// //         finance: true,

// //         warehouse: true,

// //         api: false

// //     }

// // }
// // Usage Examples
// // Check one feature
// // const { hasFeature } = useFeature();

// // if(hasFeature("finance")) {

// // }
// // Hide Finance menu for Standard plan
// // const { hasFeature } = useFeature();

// // return (
// //     <>
// //         {
// //             hasFeature("finance") &&
// //             <FinanceMenu/>
// //         }
// //     </>
// // );
// // Check multiple modules
// // const { hasAllFeatures } = useFeature();

// // if(
// //     hasAllFeatures([
// //         "inventory",
// //         "warehouse"
// //     ])
// // ){

// // }
